export interface MtApplicationAcceptSuccessPageControllerData {}

export interface MtApplicationAcceptSuccessPageControllerProps
  extends MtApplicationAcceptSuccessPageControllerData {}
